import { Link as LinkRouter } from "react-router-dom";
import styled from '@mui/material/styles/styled';

const Link = styled(LinkRouter)();

export default Link;